import { render, staticRenderFns } from "./QueryParameter.vue?vue&type=template&id=2ff1b46e&scoped=true&"
import script from "./QueryParameter.vue?vue&type=script&lang=js&"
export * from "./QueryParameter.vue?vue&type=script&lang=js&"
import style0 from "./QueryParameter.vue?vue&type=style&index=0&id=2ff1b46e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1b46e",
  null
  
)

export default component.exports